module.exports = __webpack_public_path__ + "static/media/check-circle.b8ae8dce.svg";